<transaction-list-detail-template
  [transaction]="transaction"
  (closeEmitter)="closeEmitter?.emit($event)"
  [getFrom]="getFromWalletName()"
  [getTo]="getToWalletName()"
  [networkName]="networkName | async">
  <ng-container fromWallet>{{ getFromWalletName() }}</ng-container>
  <ng-container toWallet>
    @if (getToWalletName().length > 0) {
      <span>{{ getToWalletName() }}</span>
    }
    @if (showWalletNameLink() && !isBestFeeTx()) {
      <span>
        <a [href]="tradable?.urlCheckAddress().replace('%s', transaction?.getRecipient())" [target]="'_blank'">
          {{ getRecipient() }}
        </a>
      </span>
    }
    @if (isBestFeeTx()) {
      <span>{{ getRecipient() }}</span>
    }
  </ng-container>

  <ng-container transactionId>
    <span>
      <a [href]="tradable?.urlCheckTransaction().replace('%s', transaction?.getTxId())" [target]="'_blank'">
        {{ transaction?.getTxId() }}
      </a>
    </span>
  </ng-container>
  <ng-container amountExchanged>
    @if (!storage_fee) {
      {{ getTotalAmount(false) | tradable_precision_symbol: { id: getCurrencyId(), ignorePrecision: true } }}
    }
    @if (storage_fee) {
      {{ transaction?.getFee() | tradable_precision_symbol: { id: getCurrencyId(), ignorePrecision: true } }}
    }
  </ng-container>
  <ng-container cryptoPrice>
    &#64;{{ 1 | tradable_precision_symbol: { id: getCurrencyId(), removePrecision: true } }} =
    {{
    transaction?.getTrade()?.getPrice()
    | fiat_precision_symbol
    : {
    id: txFiat?.getId(),
    symbol: true,
    currencies: [txFiat, transaction?.getTrade()?.getCurrencyId() | tradable]
  }
  }}
</ng-container>
<ng-container relatedTx>
  @if (containsSwap()) {
    <div>
      <a (click)="openSwapDetails()">{{ "swap_show_more_tx_item" | translate }}</a>
    </div>
  }
  @if (containsDebitCardRelatedTx()) {
    <div>
      <a (click)="openDebitCardDetails()">{{ "debit_card_tx_related" | translate }}</a>
    </div>
  }
</ng-container>
<ng-container sendFee>
  <div>{{ "fee" | translate }}</div>
  <div class="color-text button-weight">
    {{ transaction?.getFee() | tradable_precision_symbol: { id: getCurrencyId(), ignorePrecision: true } }}
  </div>
</ng-container>
<ng-container vsnUsed>
  {{ getVsnFeeAmount() }} VSN
</ng-container>

<ng-container vsnPrice>
  1 VSN = {{ getVsnFeeRate() | fiat_precision_symbol: { id: fiat?.getId(), symbol: true, currencies: [fiat] } }}
</ng-container>
<ng-container amountTotal>
  @if (!storage_fee) {
    {{
    getTotalAmount()
    | tradable_precision_symbol: { id: getCurrencyId(), ignorePrecision: !canOpen }
    | value_change_prefix: { isProfit: !transaction?.isOutgoing() }
    }}
  }
  @if (storage_fee) {
    {{
    transaction?.getFee()
    | tradable_precision_symbol: { id: getCurrencyId(), ignorePrecision: !canOpen }
    | value_change_prefix: { isProfit: !transaction?.isOutgoing() }
    }}
  }
</ng-container>
</transaction-list-detail-template>
